import type { SliderDataZoomOption } from 'echarts/lib/component/dataZoom/SliderZoomModel';
import type ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import type ComponentModel from 'echarts/lib/model/Component';

export function getSliderDataZoomModels(ecIns: ExtensionAPI) {
  // 获取拖动条类型的datazoom模型
  return ecIns.getModel().queryComponents({
    mainType: 'dataZoom',
    subType: 'slider'
  }) as unknown as ComponentModel<SliderDataZoomOption>[];
}
